import { heroEquipment } from "../HeroEquipment";

export const nizolki = {
  heroes: {
    Starszy: {
      id: 0,
      startingEquipment: ["Sztylet", "Miecz"],
      cost: 45,
      number: 1,
      equipmentList: heroEquipment["Nizołki z Krainy Zgromadzenia"]["Bohaterowie"],
      type: "Bohater",
      stats: {
        Początkowa: [3, 3, 4, 3, 2, 2, 5, 1, 9],
        Maksymalna: [4, 5, 7, 3, 3, 3, 9, 4, 10],
      },
      rules: [
        "Dowódca",
        "Odporność na magię (2)",
        "Ranger",
        "Śmigły",
        "W nogi!",
        "Zasadzka",
        "Zwiadowca",
      ],
      exp: 20,
      skills: [0, 1, 2, 4, 5],
    },
    "Magister Magii": {
      id: 1,
      startingEquipment: ["Sztylet", "Kostur"],
      cost: 35,
      number: 1,
      equipmentList: heroEquipment["Nizołki z Krainy Zgromadzenia"].Magister,
      type: "Bohater",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 8],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Mag (Tradycja Cienia)"],
      exp: 12,
      skills: [0, 2, 4, 5],
    },
    Sierżant: {
      id: 2,
      startingEquipment: ["Sztylet", "Halabarda"],
      cost: 25,
      number: 1,
      equipmentList: heroEquipment["Nizołki z Krainy Zgromadzenia"]["Bohaterowie"],
      type: "Bohater",
      stats: {
        Początkowa: [3, 3, 4, 2, 2, 1, 4, 1, 8],
        Maksymalna: [4, 5, 7, 3, 3, 3, 9, 4, 10],
      },
      rules: [
        "Odporność na magię (2)",
        "Podoficer",
        "Śmigły",
        "W nogi!",
        "Zasadzka",
      ],
      exp: 8,
      skills: [0, 3, 4, 5],
    },
    Zwiadowca: {
      id: 3,
      startingEquipment: ["Sztylet", "Kusza"],
      cost: 20,
      number: 2,
      equipmentList: heroEquipment["Nizołki z Krainy Zgromadzenia"]["Bohaterowie"],
      type: "Bohater",
      stats: {
        Początkowa: [3, 2, 4, 2, 2, 1, 4, 1, 8],
        Maksymalna: [4, 5, 7, 3, 3, 3, 9, 4, 10],
      },
      rules: [
        "Odporność na magię (2)",
        "Pułapkarz",
        "Ranger",
        "Śmigły",
        "W nogi!",
        "Zasadzka",
        "Zwiadowca",
      ],
      exp: 8,
      skills: [0, 1, 4, 5],
    },
    Pasterz: {
      id: 4,
      startingEquipment: ["Sztylet"],
      cost: 20,
      number: 15,
      equipmentList: heroEquipment["Nizołki z Krainy Zgromadzenia"]["Stronnicy"],
      type: "Stronnik",
      stats: {
        Początkowa: [3, 2, 4, 2, 2, 1, 4, 1, 8],
        Maksymalna: [4, 5, 7, 3, 3, 3, 9, 4, 10],
      },
      rules: [
        "Chorążowie & sygnaliści",
        "Drużyna obsługi",
        "Odporność na magię (2)",
        "Ranger",
        "Śmigły",
        "Treser",
        "W nogi!",
        "Zasadzka",
        "Zwiadowca",
      ],
    },
    Milicjant: {
      id: 5,
      startingEquipment: ["Sztylet", "Halabarda"],
      cost: 20,
      number: 5,
      equipmentList: heroEquipment["Nizołki z Krainy Zgromadzenia"]["Stronnicy"],
      type: "Stronnik",
      stats: {
        Początkowa: [3, 3, 4, 2, 2, 1, 4, 1, 8],
        Maksymalna: [4, 5, 7, 3, 3, 3, 9, 4, 10],
      },
      rules: [
        "Drużyna wsparcia",
        "Odporność na magię (2)",
        "Szermierz",
        "Śmigły",
        "W nogi!",
        "Zasadzka",
      ],
    },
    "Pies pasterski": {
      id: 6,
      startingEquipment: ["Broń naturalna"],
      cost: 15,
      number: 5,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [6, 4, 0, 4, 3, 1, 4, 1, 5],
        Maksymalna: [6, 4, 0, 4, 3, 1, 4, 1, 5],
      },
      rules: ["Sfora", "Zwierzę"],
    },
    Przepatrywacz: {
      id: 7,
      startingEquipment: [
        "Sztylet",
        "Miecz",
        "Włócznia",
        "Kuc",
        "Siodło & uprząż",
      ],
      cost: 70,
      number: 3,
      equipmentList: heroEquipment["Nizołki z Krainy Zgromadzenia"]["Stronnicy"],
      type: "Stronnik",
      stats: {
        Początkowa: [3, 2, 4, 2, 2, 1, 4, 1, 8],
        Maksymalna: [4, 5, 7, 3, 3, 3, 9, 4, 10],
        Kuc: [6, 2, 0, 4, "-", "-", 2, 1, 5],
      },
      rules: [
        "Kawalerzysta",
        "Lekka jazda",
        "Odporność na magię (2)",
        "Ranger",
        "Śmigły",
        "W nogi!",
        "Zasadzka",
        "Zwiadowca",
      ],
    },
    Ogr: {
      id: 8,
      startingEquipment: ["Maczuga ogrów"],
      cost: 160,
      number: 1,
      equipmentList: heroEquipment["Gang przemytników"]["Ogr"],
      type: "Stronnik",
      stats: {
        Początkowa: [6, 3, 2, 4, 4, 3, 2, 2, 7],
        Maksymalna: [6, 6, 5, 5, 5, 5, 6, 5, 9],
      },
      rules: [
        "Bycza szarża",
        "Duży cel",
        "Głód trzewi",
        "Oznakowany gnoblar (gnoblar-uwaga)",
        "Przepastne trzewia",
        "Strach",
        "Tempy",
        "Wielkolud",
      ],
    },
    "Wóz kuchenny": {
      id: 9,
      startingEquipment: [],
      cost: 175,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        Powóz: ["-", "-", "-", 4, 8, 8, "-", "-", "-"],
        Kuc: [6, 2, 0, 4, "-", "-", 2, 1, 5],
        "Kuc ": [6, 2, 0, 4, "-", "-", 2, 1, 5],
      },
      rules: [
        "Duży cel",
        "Kontakty handlowe (1)",
        "Kuchnia polowa",
        "Machina wojenna",
        "Powóz",
      ],
    },
  },
  limit: 500,
  minModels: 3,
  maxModels: 15,
  name: "Niziołki z Krainy Zgromadzenia",
  nature: "Neutralna",
  armyRules: ["Kompania najemników", "Rozrzutność"],
  mercenaries: [
    "Balistyk",
    "Bombardier",
    "Gladiator",
    "Kartograf",
    "Kupiec",
    "Latarnik",
    "Łowca nagród",
    "Magus",
    "Medyk",
    "Minstrel",
    "Miotacz ołowiu",
    "Ochroniarz",
    "Pogromca Trolli",
    "Poszukiwacz złota",
    "Rycerz najemny",
    "Skryba",
    "Strażnik dróg",
    "Szczurołap",
    "Szpieg",
    "Tileański kusznik",
    "Trefniś",
    "Woźnica",
    "Wróżbita",
    "Zwadźca",
  ],
};
